import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7540be36"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "solution-banner__content"
};
const _hoisted_2 = {
  class: "solution-banner__title"
};
const _hoisted_3 = {
  class: "solution-banner__subTitle"
};
const _hoisted_4 = {
  class: "solution-banner__btn-group"
};
const _hoisted_5 = {
  class: "solution-banner__tags-inner"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "solution-banner__tags-mask"
}, null, -1));
const _hoisted_7 = {
  class: "solution-banner__tag-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['solution-banner__wrap', `solution-banner__wrap-${_ctx.type}`])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.baseInfo.title), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.baseInfo.subTitle), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    size: "large",
    class: "solution-banner__btn solution-banner__btn-plain",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.router.push({
      path: '/',
      hash: '#joinus'
    }))
  }, {
    default: _withCtx(() => [_createTextVNode("预约一对一咨询")]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseInfo.child, (route, index) => {
    return _openBlock(), _createBlock(_component_router_link, {
      key: index,
      to: route.path,
      target: "_blank"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        class: "solution-banner__btn solution-banner__btn-primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(route.text), 1)]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1032, ["to"]);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseInfo.tags, tagItem => {
    return _openBlock(), _createElementBlock("div", {
      key: tagItem.title,
      class: "solution-banner__tag-item"
    }, [_createElementVNode("h3", _hoisted_7, _toDisplayString(tagItem.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagItem.desc, (des, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "solution-banner__tag-desc"
      }, _toDisplayString(des), 1);
    }), 128))]);
  }), 128))])])], 2);
}